
import React from "react";

const ErrorState: React.FC = () => {
  return (
    <div className="text-center py-12 bg-white rounded-lg shadow">
      <p className="text-xl text-red-500">Error loading businesses. Please try again later.</p>
    </div>
  );
};

export default ErrorState;
